module.exports = __webpack_public_path__ + "static/media/ytIcon.5ccaa671.svg";